  /** 
  * This is useful for avoiding non-harmful, but potentially confusing "uncaught
  * play promise" rejection error messages.
  */
  function handlePlayPromise(promiseVideo){
    if (promiseVideo !== undefined) {
      promiseVideo.then(_ => {
        // Show playing UI.
      })
      .catch(error => {
        // Play was prevented
        // Show paused UI.
      });
    }
  }

  // Remove HTML from the html string
  function stripHtml(html) {
     let doc = new DOMParser().parseFromString(html, 'text/html');
     return doc.body.textContent || "";
  }
  
  // document.addEventListener('click', (event) => {
  //   handlePlayPromise(document.querySelector('[data-reelid="685"] video').play());
  // },{once:true});

  let reelkart = {};
  let reelkartMoneyFormat = document.querySelector('reelkart-container').getAttribute('data-moneyformat') || null ;
  let reelkartStoreURL = document.querySelector('reelkart-container').getAttribute('data-storeURL') || null ;

  reelkart.formatMoney = function(cents, format = reelkartMoneyFormat) {
    this.money_format = document.querySelector('reelkart-container').getAttribute('data-moneyformat') || null ;
    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) {
        return 0;
      }

      // Shopify money convertion from cents to dollar is not required
      // number = (number/100.0).toFixed(precision);
      number = number.toFixed(precision);
  
      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      // case 'amount':
      //   value = formatWithDelimiters(cents, 2);
      //   break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }


  class reelkartContainer extends HTMLElement {
    static get observedAttributes() { return ['data-reelkart-cartcount']; }
    
    constructor() {
      super();

      // Load Video on viewport entry and exit
      this.options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.25
      };
      
      this.observer = new IntersectionObserver(this.loadMore.bind(this), this.options);
      this.loader = this.querySelector('reelload-more')
      this.observer.observe(this.loader);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      switch(name){
        case 'data-reelkart-cartcount': 
          this.querySelectorAll('.reelkart-gotocart .reelkart-cartcount').forEach(
            (cartcount) => {cartcount.innerHTML = newValue}
          );
          break;
      }
    }

    loadMore(entries, observer){
      entries.forEach( async (entry) => {
        if (entry.isIntersecting) {
          let currentPage = this.querySelector('reelkart-videos').pageLoaded;
          let result = await this.querySelector('reelkart-videos')?.loadPage(++currentPage);
        }
      })
    }
  }

  customElements.define("reelkart-container", reelkartContainer);
  

  
  class reelkartVideos extends HTMLElement {
    constructor() {
      super();
      this.videoPreviewList = []
      this.pageLoaded = 0;
      this.reelPerPage = 15;
      this.loadPage();
      this.debug = false;

      // if reel id is same of videoPreviewList load new page. This can be done based on the index of the item reached.
      // also need to avoid loop of call again and again for the same page. 
    }

    // Load specific pages and also add it to the global Preview list
    loadPage(page=1){
      let debug = this.debug
      // Creating promise so the function run only when the request is succussful
      return new Promise((resolve, reject) => { 
        if(page > this.pageLoaded) {
          // Increment the number of page loaded
          ++this.pageLoaded;
          fetch(`https://backend.reelkart.io/api/store/reels/list/${reelkartStoreURL}?page=${page}&limit=${this.reelPerPage}&mapped=true`)
          .then(response => response.json())
          .then(result => {
            this.closest("reelkart-container").classList.add('reelkart-reelsLoaded');
            const reelData = result?.data?.reelData || [];
            this.videoPreviewList.push(...reelData);
            reelData.forEach(reel => {
              // add a query to see that the video is not present on the page.
              this.insertAdjacentHTML('beforeend', `<reelkart-video video-buffered=0 data-product-title="${reel.product[0]?.title }" data-img-src="${reel.thumbnail_src}"  data-previewVideo-src="${reel.preview_src}" data-video-src="${reel.src}" data-reelId=${reel.id}></reelkart-video>`);
            });
            resolve(this.videoPreviewList);
          })
          .catch(error => {
            this.insertAdjacentHTML('beforeend', `<span style="display:block;color: red;"> Error Please refresh the page</span>`);
          });
        } else {
          reject(new Error("The page has been called already skipping this call"));
        }
      })
      .catch(function(error) {
        if(debug) { console.log(error)}
      }); 
    }
  }

  customElements.define("reelkart-videos", reelkartVideos);

  class reelkartVideo extends HTMLElement {
    constructor() {
      super();

      this.videoId = this.getAttribute("data-reelid");
      this.videoSrc = this.getAttribute("data-video-src");
      this.previewVideoSrc = this.getAttribute("data-previewVideo-src");
      this.imageSrc = this.getAttribute("data-img-src");
      this.productTitle = this.getAttribute("data-product-title");
      this.addEventListener('click', this.onReelClick.bind(this))
      
      // Pause and Play Video on viewport entry and exit
      this.options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.6
      };

      this.callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            handlePlayPromise(entry.target.play())
          }
          else {
            entry.target.pause();
          }
        });
      }

      this.observer = new IntersectionObserver(this.callback, this.options);
      this.init();
    }

    onReelClick(evt){
      let mainContainer = this.closest("reelkart-container").querySelector('reelkart-popupVideo').openReel(this.videoId,this.videoSrc,this.imageSrc);
    }

    init(){
      this.style.backgroundImage=`url(${this.imageSrc})`; 
      this.insertAdjacentHTML('beforeend', `<video width="212" height="270"  muted playsinline loop poster="${this.imageSrc}">
          <source src="${this.previewVideoSrc}" type="video/mp4">
        </video>
        <p>${this?.productTitle}</p>`);
      const video = this.querySelector("video");
      
      video.addEventListener('loadedmetadata', (event) => {
        this.setAttribute("video-buffered", "1");
        this.observer.observe(video);
      });      
    }
  }

  customElements.define("reelkart-video", reelkartVideo);

  class reelkartHighlights extends HTMLElement {
    constructor() {
      super();
      
      this.videoPreviewList = []
      this.init();
    }

    init() {
      fetch(`https://backend.reelkart.io/api/store/product/list/${reelkartStoreURL}?page=1&limit=10&highlight=true`)
      .then(response => response.json())
      .then(result => {
        const productData = result?.data?.productData || [];
        this.videoPreviewList.push(...productData);
        this.closest("reelkart-container").classList.add('reelkart-highlightsLoaded');
        result?.data?.productData?.forEach(highlight => {
          if(highlight.images.length > 0 && highlight.reels.length > 0 ) {            
            this.insertAdjacentHTML('beforeend', `<reelkart-highlight data-img-src="${highlight.images[0].src}" data-productId=${highlight.id}></reelkart-highlight>`); 
          }
        })
      })

      console.log(this.videoPreviewList);
    }
  }

  customElements.define("reelkart-highlights", reelkartHighlights);

  class reelkartHighlight extends HTMLElement {
    constructor() {
      super();
      
      this.productID = this.getAttribute("data-productid");
      this.imageSrc = this.getAttribute("data-img-src");
      
      let videoPreviewList = this.closest('reelkart-highlights').videoPreviewList;
      this.productData = videoPreviewList.find(this.isProduct.bind(this));
      this.init();
      
      this.addEventListener('click', this.open.bind(this));
    }

    init(){
      this.insertAdjacentHTML('beforeend', `<img src="${this.imageSrc}" loading="eager" width=77 height=77 >`);
    }

    isProduct(product) {
      return product.id == this.productID;
    }

    open(evt){
      this.closest("reelkart-container").querySelector('reelkart-popupVideo').openHighlight(this.productData);
    }
  }
  
  customElements.define("reelkart-highlight", reelkartHighlight);


  class reelkartPopupVideo extends HTMLElement {
    constructor() {
      super();

      // Active Media Player
      this.isMute = true;
      this.setAttribute("ismute", this.isMute);

      // Defining Part of template
      this.soundButton = `<button ref=sound >
        <svg ref=sound width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" viewBox="0,0,24,24" fill="#ffffff">
          <path ref="unmute" d="M15 23l-9.309-6h-5.691v-10h5.691l9.309-6v22zm-9-15.009v8.018l8 5.157v-18.332l-8 5.157zm14.228-4.219c2.327 1.989 3.772 4.942 3.772 8.229 0 3.288-1.445 6.241-3.77 8.229l-.708-.708c2.136-1.791 3.478-4.501 3.478-7.522s-1.342-5.731-3.478-7.522l.706-.706zm-2.929 2.929c1.521 1.257 2.476 3.167 2.476 5.299 0 2.132-.955 4.042-2.476 5.299l-.706-.706c1.331-1.063 2.182-2.729 2.182-4.591 0-1.863-.851-3.529-2.184-4.593l.708-.708zm-12.299 1.299h-4v8h4v-8z"/>
          <path  ref="mute" d="M18 23l-9.305-5.998.835-.651 7.47 4.815v-10.65l1-.781v13.265zm0-15.794l5.384-4.206.616.788-23.384 18.264-.616-.788 5.46-4.264h-2.46v-10h5.691l9.309-6v6.206zm-11.26 8.794l1.26-.984v-7.016h-4v8h2.74zm10.26-8.013v-5.153l-8 5.157v6.244l8-6.248z"/>
        </svg>
      </button>`;

      this.closeButton = `<button ref=close >
        <svg ref=close xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256" style="fill:#000000;">
          <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <g transform="scale(5.12,5.12)">
              <path d="M25,2c-12.69047,0 -23,10.30953 -23,23c0,12.69047 10.30953,23 23,23c12.69047,0 23,-10.30953 23,-23c0,-12.69047 -10.30953,-23 -23,-23zM25,4c11.60953,0 21,9.39047 21,21c0,11.60953 -9.39047,21 -21,21c-11.60953,0 -21,-9.39047 -21,-21c0,-11.60953 9.39047,-21 21,-21zM32.99023,15.98633c-0.26377,0.00624 -0.51439,0.11645 -0.69727,0.30664l-7.29297,7.29297l-7.29297,-7.29297c-0.18827,-0.19353 -0.4468,-0.30272 -0.7168,-0.30274c-0.40692,0.00011 -0.77321,0.24676 -0.92633,0.62377c-0.15312,0.37701 -0.06255,0.80921 0.22907,1.09303l7.29297,7.29297l-7.29297,7.29297c-0.26124,0.25082 -0.36648,0.62327 -0.27512,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27512l7.29297,-7.29297l7.29297,7.29297c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-7.29297,-7.29297l7.29297,-7.29297c0.29724,-0.28583 0.38857,-0.7248 0.23,-1.10546c-0.15857,-0.38066 -0.53454,-0.62497 -0.94679,-0.61524z"></path>
            </g>
          </g>
        </svg>
      </button>`;

      // Pause and Play Video on viewport entry and exit
      // And load next videos
      this.options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.6
      };

      this.callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play(entry.target);
              if(entry.target.closest('[data-reelid]').getAttribute('data-reelid') && !entry.target.closest('[data-reelid]').getAttribute('data-productid')) {
                let currentVideoId = entry.target.closest('[data-reelid]').getAttribute('data-reelid');
                entry.target.closest('.reelVideo')?.classList.remove('product-added');
                entry.target.closest('.reelVideo')?.classList.add('reelkart-active');
                setTimeout(() => { this.nextReels(currentVideoId) }, 900)
              }
            }
            else {
              entry.target.closest('.reelVideo')?.classList.remove('product-added');
              entry.target.closest('.reelVideo')?.classList.remove('reelkart-active');
              entry.target.pause();
            }
          });
      }

      this.observer = new IntersectionObserver(this.callback, this.options);

      // Event Listner
      this.addEventListener('click', this.close.bind(this));
      this.addEventListener('click', this.sound.bind(this));
      this.addEventListener('click', this.share.bind(this));
      this.addEventListener('click', this.showProduct.bind(this));
      this.addEventListener('click', this.gotocart.bind(this));
      this.addEventListener('click', this.continueReel.bind(this));
    }

    async nextReels(videoId , active = false) {
      // If elemnt is active that is the first video that need to be appended
      // and also that video need to played 
      const videoList = this.closest("reelkart-container")?.querySelector('reelkart-videos')?.videoPreviewList || [];
      const reelIndex = (reel) => reel.id == videoId;
      
      // The current reelindex
      const activeReelIndex = videoList.findIndex(reelIndex);

      // Load next page if its the last reel 
      if(videoList && videoList.length > 0 && activeReelIndex == videoList.length - 1){
        let currentPage = Math.ceil(videoList.length / (this.closest("reelkart-container")?.querySelector('reelkart-videos')?.reelPerPage || 10));
        let nextPage = currentPage + 1;
        
        const result = await this.closest("reelkart-container")?.querySelector('reelkart-videos')?.loadPage(nextPage);
      }

      // The next reel to play 
      const nextReelIndex = active ? activeReelIndex : activeReelIndex + 1;
      const nextReelId = videoList[nextReelIndex]?.id || '';

      if(videoList[nextReelIndex] && !this.querySelector(`.reelVideo[data-reelId='${nextReelId}']`)) {
        const nextReel = videoList[nextReelIndex];
        let productData = nextReel?.product[0] || {};

        if(productData.id) {
          let productTitle = productData.title ? `<h2 ref="title">${stripHtml(productData.title)}</h2>`: '';
          let productBody = productData.body_html ? `<div ref="details">${stripHtml(productData.body_html)}</div>`: '';
          let productURL = (productData.handle && (window.location.protocol + '//' + window.location.hostname+'/products/'+productData.handle)) || "";
          let productInCart = this.closest('reelkart-container').getAttribute('data-reelkart-cartcount');

          let productPriceBuyButton = productData.min_price ? `<button ref=buy >
              <span> ${reelkart.formatMoney(parseInt(productData.min_price))} </span>
              <svg ref=buy width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17 2H3C2.44772 2 2 2.44771 2 3V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V3C18 2.44772 17.5523 2 17 2ZM20 3C20 1.34315 18.6569 0 17 0H3C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3ZM10 10C12.7614 10 15 7.31371 15 4H13C13 6.56606 11.3309 8 10 8C8.66909 8 7 6.56606 7 4H5C5 7.31371 7.23858 10 10 10Z" fill="white"/>
              </svg>
            </button>`: '';                      
          
          this.insertAdjacentHTML('beforeend', `<div class="reelVideo ${ active ? 'initialReel' : ''}" data-reelId=${nextReelId} >
            <video playsinline muted loop poster=${nextReel.thumbnail_src} style="background-image: url('${nextReel.thumbnail_src}');background-position: center;">
              <source src="${nextReel.src}" type="video/mp4">
            </video>
            ${this.soundButton}
            ${this.closeButton}
            ${productPriceBuyButton}
            <button ref=share data-shareURL="${productURL}">
              <svg ref=share xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19 10.5C19 9.11929 20.1193 8 21.5 8C22.8807 8 24 9.11929 24 10.5C24 11.8807 22.8807 13 21.5 13C20.7411 13 20.0611 12.6618 19.6026 12.1279L12.885 15.2482C12.9597 15.4855 13 15.738 13 16C13 16.262 12.9597 16.5145 12.885 16.7518L19.6026 19.8721C20.0611 19.3382 20.7411 19 21.5 19C22.8807 19 24 20.1193 24 21.5C24 22.8807 22.8807 24 21.5 24C20.1193 24 19 22.8807 19 21.5C19 21.238 19.0403 20.9855 19.115 20.7482L12.3974 17.6279C11.9389 18.1618 11.2589 18.5 10.5 18.5C9.11929 18.5 8 17.3807 8 16C8 14.6193 9.11929 13.5 10.5 13.5C11.2589 13.5 11.9389 13.8382 12.3974 14.3721L19.115 11.2518C19.0403 11.0145 19 10.762 19 10.5Z" fill="white"></path>
              </svg>
            </button>
            
            <button ref=gotocart class="reelkart-gotocart">
              <svg ref="gotocart" width="20" height="20" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 1.25C0.5 0.835786 0.835786 0.5 1.25 0.5H3.5C3.84415 0.5 4.14414 0.734223 4.22761 1.0681L4.83558 3.5H22.25C22.481 3.5 22.699 3.6064 22.8412 3.78844C22.9833 3.97048 23.0336 4.20785 22.9776 4.4319L20.7276 13.4319C20.6441 13.7658 20.3442 14 20 14H6.5C6.15585 14 5.85586 13.7658 5.77239 13.4319L2.91442 2H1.25C0.835786 2 0.5 1.66421 0.5 1.25ZM5.21058 5L7.08558 12.5H19.4144L21.2894 5H5.21058ZM8 17C7.17157 17 6.5 17.6716 6.5 18.5C6.5 19.3284 7.17157 20 8 20C8.82843 20 9.5 19.3284 9.5 18.5C9.5 17.6716 8.82843 17 8 17ZM5 18.5C5 16.8431 6.34315 15.5 8 15.5C9.65685 15.5 11 16.8431 11 18.5C11 20.1569 9.65685 21.5 8 21.5C6.34315 21.5 5 20.1569 5 18.5ZM18.5 17C17.6716 17 17 17.6716 17 18.5C17 19.3284 17.6716 20 18.5 20C19.3284 20 20 19.3284 20 18.5C20 17.6716 19.3284 17 18.5 17ZM15.5 18.5C15.5 16.8431 16.8431 15.5 18.5 15.5C20.1569 15.5 21.5 16.8431 21.5 18.5C21.5 20.1569 20.1569 21.5 18.5 21.5C16.8431 21.5 15.5 20.1569 15.5 18.5Z" fill="white"></path>
              </svg>
              <span ref="gotocart" class="reelkart-cartcount">${productInCart}</span>
            </button>
            
            <div class="reelDetails">
              ${productTitle}
              ${productBody}
              <a ref="showProduct">more</a>
            </div>
            
            <div class="afterAdd">
              <button type="button" ref="continue">
                Continue Shopping
              </button>
              <button type="button" ref="gotocart">
                Go to cart
              </button>
            </div>
          </div>`); 
        }


        // Add observer to play video
        const nextReelElement = this.querySelector(`.reelVideo[data-reelId='${nextReelId}'] video`);
        if(nextReelElement) {
          if(active){this.play(nextReelElement)};
          this.observer.observe(nextReelElement);  
        }
      }
    }

    async nextHighlights(videoId , product , active = false) {
      
      // If elemnt is active that is the first video that need to be appended
      // and also that video need to played 
      const videoList = product.reels || [];
      const reelIndex = (reel) => reel.id == videoId;
      
      // The current reelindex
      const activeReelIndex = videoList.findIndex(reelIndex);

      // The next reel to play 
      const nextReelIndex = active ? activeReelIndex : activeReelIndex + 1;
      const nextReelId = videoList[nextReelIndex]?.id || '';

      if(videoList[nextReelIndex] && !this.querySelector(`.reelVideo[data-reelId='${nextReelId}']`)) {
        const nextReel = videoList[nextReelIndex];
        let productData = product || {};

        if(productData.id) {
          let productTitle = productData.title ? `<h2 ref="title">${stripHtml(productData.title)}</h2>`: '';
          let productBody = productData.body_html ? `<div ref="details">${stripHtml(productData.body_html)}</div>`: '';
          let productURL = (productData.handle && (window.location.protocol + '//' + window.location.hostname+'/products/'+productData.handle)) || "";
          let productInCart = this.closest('reelkart-container').getAttribute('data-reelkart-cartcount');
          
          this.insertAdjacentHTML('beforeend', `<div class="reelVideo ${ active ? 'initialReel' : ''}" data-productid=${productData.id} data-reelId=${nextReelId} >
            <video playsinline muted loop poster=${nextReel.thumbnail_src} style="background-image: url('${nextReel.thumbnail_src}');background-position: center;">
              <source src="${nextReel.src}" type="video/mp4">
            </video>
            ${this.soundButton}
            ${this.closeButton}
            ${this.buyButton}

            <button ref=share data-shareURL="${productURL}">
              <svg ref=share xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19 10.5C19 9.11929 20.1193 8 21.5 8C22.8807 8 24 9.11929 24 10.5C24 11.8807 22.8807 13 21.5 13C20.7411 13 20.0611 12.6618 19.6026 12.1279L12.885 15.2482C12.9597 15.4855 13 15.738 13 16C13 16.262 12.9597 16.5145 12.885 16.7518L19.6026 19.8721C20.0611 19.3382 20.7411 19 21.5 19C22.8807 19 24 20.1193 24 21.5C24 22.8807 22.8807 24 21.5 24C20.1193 24 19 22.8807 19 21.5C19 21.238 19.0403 20.9855 19.115 20.7482L12.3974 17.6279C11.9389 18.1618 11.2589 18.5 10.5 18.5C9.11929 18.5 8 17.3807 8 16C8 14.6193 9.11929 13.5 10.5 13.5C11.2589 13.5 11.9389 13.8382 12.3974 14.3721L19.115 11.2518C19.0403 11.0145 19 10.762 19 10.5Z" fill="white"></path>
              </svg>
            </button>
            
            <button ref=gotocart class="reelkart-gotocart">
              <svg ref="gotocart" width="20" height="20" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 1.25C0.5 0.835786 0.835786 0.5 1.25 0.5H3.5C3.84415 0.5 4.14414 0.734223 4.22761 1.0681L4.83558 3.5H22.25C22.481 3.5 22.699 3.6064 22.8412 3.78844C22.9833 3.97048 23.0336 4.20785 22.9776 4.4319L20.7276 13.4319C20.6441 13.7658 20.3442 14 20 14H6.5C6.15585 14 5.85586 13.7658 5.77239 13.4319L2.91442 2H1.25C0.835786 2 0.5 1.66421 0.5 1.25ZM5.21058 5L7.08558 12.5H19.4144L21.2894 5H5.21058ZM8 17C7.17157 17 6.5 17.6716 6.5 18.5C6.5 19.3284 7.17157 20 8 20C8.82843 20 9.5 19.3284 9.5 18.5C9.5 17.6716 8.82843 17 8 17ZM5 18.5C5 16.8431 6.34315 15.5 8 15.5C9.65685 15.5 11 16.8431 11 18.5C11 20.1569 9.65685 21.5 8 21.5C6.34315 21.5 5 20.1569 5 18.5ZM18.5 17C17.6716 17 17 17.6716 17 18.5C17 19.3284 17.6716 20 18.5 20C19.3284 20 20 19.3284 20 18.5C20 17.6716 19.3284 17 18.5 17ZM15.5 18.5C15.5 16.8431 16.8431 15.5 18.5 15.5C20.1569 15.5 21.5 16.8431 21.5 18.5C21.5 20.1569 20.1569 21.5 18.5 21.5C16.8431 21.5 15.5 20.1569 15.5 18.5Z" fill="white"></path>
              </svg>
              <span ref="gotocart" class="reelkart-cartcount">${productInCart}</span>
            </button>
            
            
            <div class="reelDetails">
              ${productTitle}
              ${productBody}
              <a ref="showProduct">more</a>
            </div>
            
            <div class="afterAdd">
              <button type="button" ref="continue">
                Continue Shopping
              </button>
              <button type="button" ref="gotocart">
                Go to cart
              </button>
            </div>
          </div>`); 
        }


        // Add observer to play video
        const nextReelElement = this.querySelector(`.reelVideo[data-reelId='${nextReelId}'] video`);
        if(nextReelElement) {
          if(active){this.play(nextReelElement)};
          this.observer.observe(nextReelElement);  
        }
      }
    }

    //Play Video and set audio
    play(videoElement) {
      setTimeout(() => {
        handlePlayPromise(videoElement.play());
        videoElement.muted = this.isMute;
      }, 500)
    }

    pause() {
      console.log('Pause is called');
    }

    //Open the popup video
    openReel(videoId,videoUrl,imageUrl) {
      
      // Add video to the popup and play 
      this.nextReels(videoId,true)

      // Open the popup and disable body scroll 
      document.body.classList.add('reelkart-open');
      this.setAttribute("open", "1");
      this.scrollTop = 0;

      // Get next set of video and load them
      this.nextReels(videoId);
    }

    openHighlight(product) {
      // Add video to the popup and play 
      let reels = product.reels;
      if(reels && reels.length > 0){
        reels.forEach((reel, index)=>{
          this.nextHighlights(reel.id,product);
        })
      }
      
      // Open the popup and disable body scroll 
      document.body.classList.add('reelkart-open');
      this.setAttribute("open", "1");
      this.scrollTop = 0;
    }

    // Setting state to mute and unmute of videos
    sound(evt) {
      if(evt && evt.target?.getAttribute('ref') == 'sound' ) {
        this.isMute = !this.isMute;
        this.setAttribute("ismute", this.isMute);
        evt.target.closest('.reelVideo').querySelector('video').muted = this.isMute;
      }
    }

    share(evt){
      if(evt && evt.target?.getAttribute('ref') == 'share') {
        let shareUrl = evt.target.closest('.reelVideo').querySelector('[data-shareurl]').getAttribute('data-shareurl') || '';
        if(shareUrl) {
          shareUrl = 'https://api.whatsapp.com/send?&text='+ encodeURIComponent('I want to buy this product '+shareUrl)
          window.open(shareUrl, '_blank').focus();
        }
      }
    }

    showProduct(evt){
      if(evt && evt.target?.classList.contains('reelDetails') || evt && evt.target.closest('.reelDetails') 
         || evt && evt.target.closest('[ref="buy"]') || evt && evt.target?.getAttribute('ref') == 'buy') {

        let productId = evt.target.closest('.reelVideo').getAttribute('data-productid') || '';
        if(productId) {
         this.closest('reelkart-container').querySelector('reelkart-product').setAttribute('data-productid',productId); 
          return;
        }
        
        let reelId = evt.target.closest('.reelVideo').getAttribute('data-reelid') || '';
        if(reelId) {
         this.closest('reelkart-container').querySelector('reelkart-product').setAttribute('data-reelid',reelId); 
        }
      }
    }

    gotocart(evt){
      if(evt && evt.target?.classList.contains('reelkart-gotocart') || evt && evt.target.closest('.reelkart-gotocart') ||
        evt && evt.target?.getAttribute('ref') == 'gotocart') {
        window.location = window.location.protocol + '//' + window.location.hostname+'/cart';
      }
    }

    continueReel(evt) {
      if(evt && evt.target?.getAttribute('ref') == "continue") {
        evt.target.closest('.reelVideo')?.classList.remove('product-added');
        
        if(evt.target.closest('.reelVideo')){
          let nextReel = evt.target.closest('.reelVideo').nextSibling
          if(nextReel) {
            //Move to the next reel
            nextReel.scrollIntoView({behavior: "smooth"});
          }
        }
      }
    }
    
    close(evt){
      // If clicking on the outer continer or clicking on back/close button
      if(evt && evt.target == this || evt && evt.target?.getAttribute('ref') == 'close' ) {
        // remove overscroll from body
        document.body.classList.remove('reelkart-open');
        this.removeAttribute("open");
        
        while (this.childNodes.length) {
          // This is require to disconnect the events of each of child elements.
          this.removeChild(this.lastChild);
        }
        return;
      }
    }
  }
  customElements.define("reelkart-popupvideo", reelkartPopupVideo);

  class reelkartProduct extends HTMLElement {
    static get observedAttributes() { return ['data-reelid','data-productid']; }
    
    constructor() {
      super();
      
      this.productData = {};
      this.addEventListener('click', this.close.bind(this));
      this.addEventListener('click', this.addToCart.bind(this));
      this.addEventListener('click', this.buynow.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
      switch(name){
        case 'data-reelid': this.loadProduct(newValue,false);
          break;
        case 'data-productid': this.loadProduct(false,newValue);
          break;
      }
    }

    generateSelectOption(option,index){
      let selectOption =  
        `<select name="${option.name}" class="reelOption-${index}" id="reelOption-${index}">`;
           option.values.forEach((value, indx)=>{
              selectOption += `<option value="${value}" ${indx == 0 ? 'selected':''} >${value}</option>`
            })
          selectOption += `</select>`;
      return selectOption;
    }

    loadProduct(withReelID,withProductID){
      let videoDetails;
      this.reelID = withReelID;
      
      if(withReelID) {
        const videoList = this.closest("reelkart-container")?.querySelector('reelkart-videos')?.videoPreviewList || [];
        const reelIndex = (reel) => reel.id == withReelID;
        const activeReelIndex = videoList.findIndex(reelIndex);

        // The current reelindex
        videoDetails = videoList[activeReelIndex];
        this.productData = videoDetails?.product[0] || {};
      } else if(withProductID){
        this.closest("reelkart-container").querySelectorAll('.reelVideo.reelkart-active').forEach((el) => {
           this.reelID = el.getAttribute('data-reelid')
        })
        
        this.productData = this.closest("reelkart-container")?.querySelector(`reelkart-highlight[data-productid="${withProductID}"]`)?.productData || {};
      }

      if(videoDetails && videoDetails.is_mapped && videoDetails.product || withProductID ){
        let productTitle = this.productData?.title ? `<h2 ref="title">${stripHtml(this.productData.title)}</h2>`: '';
        let productBody = this.productData?.body_html ? `<div ref="details">${stripHtml(this.productData.body_html)}</div>`: '';
        let isDefaultVariant = this.productData.variants.length == 1 && this.productData.variants[0].title == "Default Title";

        
        let variantSelector = '<reelkart-variantselector>';
        this.productData.options.forEach((option,index)=>{
          variantSelector += `<div class="reelKartVariant-select">
            <label class="reelKartVariant-heading" for="reelOption-${index}">${option.name}</label>
            <div class="select-variant">
              ${this.generateSelectOption(option,index)}
            </div>
          </div>`
        })
        variantSelector += '</reelkart-variantselector>';

      let imageContent = this.productData?.images[0]?.src ? `<img class="reelProductImg" src="${this.productData?.images[0]?.src}">`: ''; 

        let quantityButtons = `<div class="reelKart-quantity">
          <label class="quantity-head">Quantity</label> 
          <quantity-input class="reelKart-quantityInput">
            <button name="minus" type="button">–</button>
            <input type="number" name="quantity" min="1" value="1" disabled>
            <button name="plus" type="button">+</button>
          </quantity-input>
        </div>`

        let priceContainer = `<div class="reelKartprice-contianer">
          <div class="reelKartprice-heading">Price</div>
          <div class="reelKartprice">
          <span class="compare-at-price">Loading...</span>
          <span class="selling-price">Loading...</span>
          </div>
        </div>`

        let closeButton = `<button ref=close >
        <svg ref=close xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256" style="fill:#000;">
          <g fill="#000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <g transform="scale(5.12,5.12)">
              <path d="M25,2c-12.69047,0 -23,10.30953 -23,23c0,12.69047 10.30953,23 23,23c12.69047,0 23,-10.30953 23,-23c0,-12.69047 -10.30953,-23 -23,-23zM25,4c11.60953,0 21,9.39047 21,21c0,11.60953 -9.39047,21 -21,21c-11.60953,0 -21,-9.39047 -21,-21c0,-11.60953 9.39047,-21 21,-21zM32.99023,15.98633c-0.26377,0.00624 -0.51439,0.11645 -0.69727,0.30664l-7.29297,7.29297l-7.29297,-7.29297c-0.18827,-0.19353 -0.4468,-0.30272 -0.7168,-0.30274c-0.40692,0.00011 -0.77321,0.24676 -0.92633,0.62377c-0.15312,0.37701 -0.06255,0.80921 0.22907,1.09303l7.29297,7.29297l-7.29297,7.29297c-0.26124,0.25082 -0.36648,0.62327 -0.27512,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27512l7.29297,-7.29297l7.29297,7.29297c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-7.29297,-7.29297l7.29297,-7.29297c0.29724,-0.28583 0.38857,-0.7248 0.23,-1.10546c-0.15857,-0.38066 -0.53454,-0.62497 -0.94679,-0.61524z"></path>
            </g>
          </g>
        </svg>
      </button>`;

        let buyButtons = `<div class="reelKart-buy">
          <button type="submit" name="add" ref="addtocart" class="product-form__submit">
            <span class="add-to-cart">Add to cart</span>
            <span class="sold-out" style="display:none;">Sold Out</span>
          </button>
          <button type="submit" name="add" ref="buynow" class="buy-it-now">
            <span class="add-to-cart">Purchase</span>
          </button>
        </div>`

        this.insertAdjacentHTML('beforeend', `<div class="reelProduct ${isDefaultVariant ? 'reeldefaultVariant':''}" data-reelId=${withReelID} >
            ${closeButton}
            ${imageContent}
            ${productTitle}
            ${productBody}
            ${variantSelector}
            ${quantityButtons}
            ${priceContainer}
            ${buyButtons}
          </div>
        `);
      }
    }

    addToCart(evt){
      if((evt && evt.target?.getAttribute('ref') == 'addtocart') || (evt && evt.target.closest('[ref=addtocart]'))) {
        let variant = evt.target?.closest('reelkart-product').querySelector('reelkart-variantselector').currentVariant;
        let quantity = evt.target?.closest('reelkart-product').querySelector('[name="quantity"]').value || 1;

        fetch('/cart/add.js', {
          method: "post",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({
            items: [{
                quantity: quantity,
                id: variant.id
            }]
          })
        })
        .then((data)=> {
          fetch(`https://reelkart-b.marmeto.com/api/store/reel/addcart/${this.reelID}/${reelkartStoreURL}`, {
            method: "post"
          })
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          let reelID = evt.target?.closest('reelkart-product').getAttribute('data-reelid');
          let productID = evt.target?.closest('reelkart-product').getAttribute('data-productid');
          
          reelID ? evt.target?.closest('reelkart-container').querySelector(`.reelVideo[data-reelid="${reelID}"]`).classList.add('product-added'): evt.target?.closest('reelkart-container').querySelector(`.reelVideo[data-productid="${productID}"]`).classList.add('product-added');
          
          fetch('/cart.js', {
            method: "get",
            headers: {
              "content-type": "application/json"
            }
          })
          .then( response => response.json())
          .then( data => { 
            evt.target?.closest('reelkart-container').setAttribute('data-reelkart-cartcount',data.item_count);
            while (this.childNodes.length) {
              this.removeChild(this.lastChild);
            }
            this.removeAttribute('data-reelid');
            this.removeAttribute('data-productid');
          })
          .catch((error) => { console.log(error)})
        });

      }
    }

    buynow(evt){
      if((evt && evt.target?.getAttribute('ref') == 'buynow') || (evt && evt.target.closest('[ref=buynow]'))) {
        let variantID = evt.target?.closest('reelkart-product').querySelector('reelkart-variantselector').currentVariant;
        let quantity = evt.target?.closest('reelkart-product').querySelector('[name="quantity"]').value || 1;
        let buynowURL = (variantID && (window.location.protocol + '//' + window.location.hostname+'/cart/'+ variantID.id + ':' + quantity + "?ref=reelkart" )) || "";
        
        if(buynowURL) {
          while (this.childNodes.length) {
            this.removeChild(this.lastChild);
          }
          this.removeAttribute('data-reelid'); 
          this.removeAttribute('data-productid');
          window.open(buynowURL, '_blank').focus();  
        }
      }
    }

    close(evt){
      // If clicking on the outer continer or clicking on back/close button
      if(evt && evt.target == this || evt && evt.target?.getAttribute('ref') == 'close' ) {
        // Close the popup
        this.removeAttribute("data-reelid");
        this.removeAttribute('data-productid');
        
        while (this.childNodes.length) {
          // This is require to disconnect the events of each of child elements.
          this.removeChild(this.lastChild);
        }
        return;
      }
    }
  }
  customElements.define("reelkart-product", reelkartProduct);

  class reelkartQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('reelkart-quantityinput', reelkartQuantityInput);

  class reelkartVariantSelector extends HTMLElement {
    constructor() {
      super();
      
      this.variantData = this.closest('reelkart-product')?.productData?.variants || {};
      this.addEventListener('change',this.variantChange.bind(this));
      
      this.variantChange();
    }

    getCurrentVariant(){
      this.optionsSelected = Array.from(this.querySelectorAll('select'), (select) => select.value);
      
      this.currentVariant = this.variantData.find((variant) => {
        return !this.optionsSelected.map((option, index) => {
          if(index == 0)
            return variant.title === "Default Title" || variant.option1 == option;

          if(index == 1)
          return variant.option2 == option;

          if(index == 2)
          return variant.option3 == option;
        }).includes(false);
      });
    }

    updatePrice(){
      if(this.currentVariant) {
        let comparePrice = parseFloat(this.currentVariant.compare_at_price);
        let price = parseFloat(this.currentVariant.price);
        
        if(comparePrice > price) {
          this.closest('reelkart-product').querySelector('.compare-at-price').style.display = 'block';
          this.closest('reelkart-product').querySelector('.compare-at-price').innerHTML = reelkart.formatMoney(comparePrice);
        } else {
          this.closest('reelkart-product').querySelector('.compare-at-price').style.display = 'none';
        }
        
        this.closest('reelkart-product').querySelector('.selling-price').innerHTML = reelkart.formatMoney(price);
      }
    }

    updateBuyButton(){
      if(this.currentVariant) {        
        this.closest('reelkart-product').querySelector('button[ref="addtocart"]').removeAttribute('disabled',true);
        this.closest('reelkart-product').querySelector('button[ref="addtocart"] .sold-out').style.display = 'none';
        this.closest('reelkart-product').querySelector('button[ref="addtocart"] .add-to-cart').style.display = 'block';
      
        this.closest('reelkart-product').querySelector('button[ref="buynow"]').removeAttribute('disabled',true);
      } else {
        this.closest('reelkart-product').querySelector('button[ref="addtocart"]').setAttribute('disabled',true);
        this.closest('reelkart-product').querySelector('button[ref="addtocart"] .sold-out').style.display = 'block';
        this.closest('reelkart-product').querySelector('button[ref="addtocart"] .add-to-cart').style.display = 'none';
        
        this.closest('reelkart-product').querySelector('button[ref="buynow"]').setAttribute('disabled',true);
      }
    }

    variantChange(evt){
      this.getCurrentVariant();
      this.updatePrice();
      this.updateBuyButton();
    }
  }
  customElements.define("reelkart-variantselector", reelkartVariantSelector);
  